var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileImage = function SvgFileImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3v26h20V9.594l-.281-.313-6-6L19.406 3Zm2 2h10v6h6v16H8Zm12 1.438L22.563 9H20ZM21.094 14c-.551 0-1 .45-1 1s.449 1 1 1 1-.45 1-1-.45-1-1-1M14 15.594l-.719.687-4 4 1.438 1.438L14 18.437l2.281 2.282.719.687.719-.687L19 19.437l2.281 2.282 1.438-1.438-3-3-.719-.687-.719.687L17 18.563l-2.281-2.282Z"
  })));
};
export default SvgFileImage;